module.exports = __webpack_public_path__ + "static/zuri-emrax-logo-c0c25638273bc854664fd9ff16099c04.jpg";